import { Spin } from 'antd';

import { useLocalFileByUUID } from '@shared/hooks/localFiles';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import 'react-image-crop/dist/ReactCrop.css';

import css from './styles.module.scss';

import defaultImg from '@/assets/images/PortraitPlaceholder.png';

const AvatarComponent = props => {
  const photoUuid = props.user?.localPhotoUuid || props.user?.photoUuid;

  const [currentAvatar, isLoader] = useLocalFileByUUID(photoUuid, { defaultImg });

  return (
    <Spin spinning={isLoader}>
      <div
        className={classNames(css['app-profline-avatar__ava'], {
          [css['app-profline-avatar__ava__small']]: props.small,
          [props.className]: !!props.className,
        })}
      >
        <img src={currentAvatar} alt='' data-qa='myProfileAvatar' />
      </div>
    </Spin>
  );
};

AvatarComponent.propTypes = {
  user: PropTypes.shape({
    localPhotoUuid: PropTypes.string,
    photoUuid: PropTypes.string,
  }),
  small: PropTypes.bool,
  className: PropTypes.string,
};

export const Avatar = AvatarComponent;
